import React, { useState, useEffect, useRef } from 'react';
import { withRouter } from "react-router-dom";
import { post } from '../../helpers/api_helper';
import Loader from '../../component/Loader';
import { POST_ADD_EDIT_AREA, POST_GET_AREA_DETAIL } from '../../helpers/url_helper';
import { toast } from 'react-toastify';
import SimpleReactValidator from 'simple-react-validator';
import { Helmet } from "react-helmet";
import { Link, useHistory } from "react-router-dom";

const UserRole = props => {
    let history = useHistory();

    const [isLoader, setLoader] = useState(0);
    const simpleValidator = useRef(new SimpleReactValidator());
    const [ButtonDisabled, SetButtonDisabled] = useState(false);
    const [form_inputs, setInputs] = useState({ 'areaId': 0, 'name': '','areaTyle' : '', longitude : '',latitude : '' });
    const [title, setTitle] = useState('Add Area');
    const [, forceUpdate] = useState();

    useEffect(() => {
        async function get_detaile() {
            if (props.match.params.id) {
                setTitle('Edit Area');
                var res_data = await post(POST_GET_AREA_DETAIL, { 'areaId': props.match.params.id }, {});
                if (res_data.status) {
                    setInputs(res_data.data.detail);
                } else {
                    toast.error(res_data.message);
                    history.push("/");
                }
            }
            setLoader(1);
        }
        get_detaile();
    }, [props.match.params.id])


    // form submit event
    const handleSubmit = async (event) => {
        event.preventDefault();
        const formValid = simpleValidator.current.allValid()
        if (!formValid) {
            simpleValidator.current.showMessages(true);
            forceUpdate(1);
        } else {
            SetButtonDisabled(true);
            var res_data = await post(POST_ADD_EDIT_AREA, form_inputs, {});
            if (res_data.status) {
                toast(res_data.message);
                history.push("/area");
            } else {
                toast.error(res_data.message);
            }
            SetButtonDisabled(false);
        }
    }

    // input text change handler
    const handleInputChange = (event) => {
        event.persist();
        setInputs(inputs => ({ ...form_inputs, [event.target.name]: event.target.value }));
    }


    if (!isLoader) {
        return (<Loader></Loader>);
    }

    return (
        <>
            <Helmet>
                <meta charSet="utf-8" />
                <title>YouSold | {title}</title>
            </Helmet>

            <div className='row mt-3'>
                <div className='col-sm-6'>
                    <div className='card'>
                        <div className="card-header">
                            <h6 className='m-0'>{title}</h6>
                        </div>
                        <div className='card-body'>
                            <form className="av-invalid" onSubmit={handleSubmit}>
                                <div className="form-group mb-4">
                                    <label className="form-label text-capitalize">Select Type</label>
                                    <select name='areaTyle' value={form_inputs.areaTyle} onChange={handleInputChange} className="form-control">
                                        <option value="">Select Type</option>
                                        <option value="Area">Area</option>
                                        <option value="Airport">Airport</option>
                                        <option value="City">City</option>
                                    </select>
                                    {simpleValidator.current.message('area tyle', form_inputs.areaTyle, 'required')}
                                </div>
                                <div className="form-group mb-4">
                                    <label className="form-label text-capitalize">Area Name</label>
                                    <input name="name" value={form_inputs.name} onChange={handleInputChange} className="form-control" type="text" />
                                    {simpleValidator.current.message('name', form_inputs.name, 'required')}
                                </div>
                                <div className="form-group mb-4">
                                    <label className="form-label text-capitalize">Latitude</label>
                                    <input name="latitude" value={form_inputs.latitude} onChange={handleInputChange} className="form-control" type="text" />
                                </div>
                                <div className="form-group mb-4">
                                    <label className="form-label text-capitalize">Longitude</label>
                                    <input name="longitude" value={form_inputs.longitude} onChange={handleInputChange} className="form-control" type="text" />
                                </div>

                                
                                <div className="text-center mt-4">
                                    <button disabled={ButtonDisabled} type="submit" className='btn btn-primary c-btn-primary pt-1 pb-1 pl-3 pr-3'>{ButtonDisabled && <i className="fa fa-spinner me-2 fa-spin"></i>} Submit</button>
                                    <Link to="/area" className='btn btn-danger c-btn-danger ml-3 pt-1 pb-1 pl-3 pr-3'>Cancel</Link>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
export default withRouter(UserRole)
